const PlusIcon = () => {
    return (
        <span
            style={{
                fontSize: '18px',
                marginRight: '4px',
            }}
        >
            +
        </span>
    );
};

export default PlusIcon;
